import { useState } from 'react';

function PasswordInput({ id, label, value, onChange, className = 'login-input', ...inputProps }) {
  const [isVisible, setIsVisible] = useState(false);
  const action = isVisible ? 'Hide' : 'Show';

  return (
    <div className="password-input-control">
      <input
        {...inputProps}
        id={id}
        type={isVisible ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        className={className}
      />
      <button
        className="password-visibility-toggle"
        type="button"
        aria-label={`${action} ${label}`}
        aria-pressed={isVisible}
        onClick={() => setIsVisible((current) => !current)}
      >
        <span aria-hidden="true">👁</span>
      </button>
    </div>
  );
}

export default PasswordInput;
